export default [{
        name: 'Dashboard',
        icon: 'ti-file',
        collapsed: true,
        children: [{
            name: 'Dashboard',
            icon: 'user',
            path: '/dashboard/avanti'
        }]
    },

    {
        name: 'Admisiones',
        icon: 'ti-user',
        collapsed: true,
        children: [{
                name: 'Ingreso de pacientes',
                icon: 'user',
                path: '/admisiones/ingreso'
            },
            {
                name: 'Pacientes Registrados',
                icon: 'user',
                path: '/admisiones/pacientes'
            },
            {
                name: 'Ingreso de autorizaciones',
                icon: 'user',
                path: '/admisiones/servicios'
            }
        ]
    },

    {
        name: 'Historia Clínica',
        icon: 'ti-folder',
        collapsed: true,
        children: [{
                name: 'Historia Clínica',
                path: '/historiaClinica/historia'
            },

        ]
    },
    {
        name: 'Mantenimiento',
        icon: 'ti-settings',
        collapsed: true,
        children: [{
                name: 'Eps',
                path: '/mantenimiento/mantenimientoEps'
            },
            {
                name: 'Patologías',
                path: '/mantenimiento/mantenimientoPatologias'
            },
            {
                name: 'Motivo de Consulta',
                path: '/mantenimiento/mantenimientoMC'
            },

        ]
    },

    {
        name: 'Acceso',
        icon: 'ti-shift-right',
        collapsed: true,
        children: [{
                name: 'Usuarios',
                path: '/acceso/usuario'
            },
            {
                name: 'Roles',
                path: '/acceso/roles'
            },


        ]
    },

    {
        name: 'Diario de campo',
        icon: 'ti-agenda',
        collapsed: true,
        children: [{
                name: 'Evoluciones',
                path: '/diarioCampo/evoluciones'
            },
            {
                name: 'Objetivos y Logros',
                path: '/diarioCampo/objetivos-y-logros'
            },
            {
                name: 'Objetivos y Logros en Familia',
                path: '/diarioCampo/objetivos-logros-familia'
            },


        ]
    },

    {
        name: 'ProgramaciónTTTTTTTT',
        icon: 'ti-alarm-clock',
        collapsed: true,
        children: [{
                name: 'ProgramacióDSCSCDEVDSVn de citas',
                path: '/programacion/programacion-citas'
            }



        ]
    },
    {
        name: 'Exámenes',
        icon: 'ti-alarm-clock',
        collapsed: true,
        children: [{
                name: 'Psicologia de Niños',
                path: '/examenes/psicologia-ninos'
            }



        ]
    }


]


// WEBPACK FOOTER //
// ./src/sidebarLlinksAdmi.js